(function(module) {
    'use strict';

    function NavigationController($scope, Store, $state) {
        // Data
        this.bodyEl = angular.element('body');

        this.folded = Store.getFoldedMenu();
        this.msScrollOptions = {
            suppressScrollX: true,
        };

        // Methods
        this.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            const newValue = !this.folded;
            this.folded = newValue;
            Store.setFoldedMenu(newValue);

        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', () => {
            this.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        this.goHome = () => {
            $state.go('root.home');
        };
    }

    module
        .controller('NavigationController', NavigationController);

})(angular.module('rocket.components'));
